import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { Item } from '../../../core/components/listbox/listbox.component';
import { FormButton } from '../../../core/components/form-field-button/form-field-button.component';

@Component({
  selector: 'tt-stock-place-del-time',
  templateUrl: './stock-place-del-time.component.html',
  styleUrls: ['./stock-place-del-time.component.css']
})
export class StockPlaceDelTimeComponent implements OnInit {
    stockPlaceDelTimeKeyno;

    public edit?: Edit;

    public selectListPickJobGroups: Item[] = [];

    public pickJobGroupsButtons: FormButton[] = [{ id: 'list', type: 'primary', icon: 'fa fa-solid fa-bars', goto: 'pickjobgrps', gotoParms: () => this.edit?.stockplace_id_from ?? '' }];

    public saving = false;

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.stockPlaceDelTimeKeyno = this.stateService.getStateParams()['stockplacedeltime_keyno'];
    }

    private async loadEdit() {
        if (!!this.stockPlaceDelTimeKeyno) {
            this.edit = (await this.datatask.Post(783, { stockplacedeltime_keyno: this.stockPlaceDelTimeKeyno }))[0];
        }
    }

    private async loadPickJobGroups(): Promise<void> {
        if (this.edit?.stockplace_id_from) {
            this.selectListPickJobGroups = await this.datatask.Post(2165, { stockplace_id: this.edit.stockplace_id_from });
        }
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                this.datatask.Post(784, this.edit);

                this.stateService.back();
            } finally {
                this.saving = false;
            }
        }
    }

    private async init() {
        await this.loadEdit();
        this.loadPickJobGroups();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    stockplacedeltime_keyno: number;
    stockplace_name_from: string;
    stockplace_name_to: string;
    deliverydays: number;
    alternate_order: number;
    exclude_from_autoplanning: number;
    pickjobgrp_keyno: number;
    stockplace_id_from: string;
}

//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('stockPlaceDelTime', {
//        templateUrl: 'views/components/views/stockPlaceDelTime/stockPlaceDelTime.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', '$q', 'stateService', 'utilityService', 'stockPlaceDelTimeService', 'pickJobGrpsService', function ($stateParams, $q, stateService, utilityService, stockPlaceDelTimeService, pickJobGrpsService) {
//            const vm = this;
//            let stockPlaceDelTimeKeyno = $stateParams.stockplacedeltime_keyno;

//            vm.model = {
//                pickJobGroupsButtons: [
//                    { id: 'list', icon: 'fa fa-solid fa-bars', color: 'primary', type: 'primary', onClick: () => stateService.go('pickjobgrps', { stockplace_id: vm.model.edit.stockplace_id_from }) }
//                ],
//                edit: {},
//                selectListPickJobGroups: [],
//                lockedSave: false
//            };

//            let loadEdit = function () {
//                const deferred = $q.defer();

//                stockPlaceDelTimeService.getEdit({ stockplacedeltime_keyno: stockPlaceDelTimeKeyno }).then(function (info) {
//                    angular.copy(info[0], vm.model.edit);

//                    loadPickJobGroups();

//                    deferred.resolve();
//                });

//                return deferred.promise;
//            };

//            let loadPickJobGroups = function () {
//                if (utilityService.validateParmsValue(vm.model.edit.stockplace_id_from) !== true) return;

//                return pickJobGrpsService.listPickJobGroups({ stockplace_id: vm.model.edit.stockplace_id_from }).then(function (list) {
//                    angular.copy(list, vm.model.selectListPickJobGroups);
//                });
//            };

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                stockPlaceDelTimeService.saveObj(vm.model.edit).then(function () {
//                    vm.model.lockedSave = false;
//                    stateService.back();
//                }, function () {
//                    vm.model.lockedSave = false;
//                });
//            };

//            vm.$onInit = function () {
//                loadEdit();
//            };
//        }]
//    });
//})();
